import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const HowToMeasure = (props) => {
    const { t } = useTranslation();
    const { mannequinGender } = props;
    const mannequinClass = useMemo(() => {
        return 'sizechart__mannequin sizechart__mannequin--' + mannequinGender;
    }, [mannequinGender]);
    const mannequinLabelText = useMemo(() => {
        switch (mannequinGender) {
            case 'men-top':
                return [
                    { title: 'neck', desc: 'neckdesc' },
                    { title: 'chest', desc: 'chestdesc' },
                    { title: 'waist.tops', desc: 'waistdesc.tops' },
                ];
            case 'men-bottom':
                return [
                    { title: 'waist.bottoms', desc: 'waistdesc.bottoms' },
                    { title: 'pelvic', desc: 'pelvicdesc' },
                ];
            case 'glove':
                return [
                    {
                        title: 'length.gloves',
                        desc: 'lengthdesc.gloves',
                    },
                ];
            case 'belt':
                return [
                    {
                        title: 'length.belts',
                        desc: 'lengthdesc.belts',
                    },
                ];
            case 'hat':
                return [
                    {
                        title: 'length.hats',
                        desc: 'lengthdesc.hats',
                    },
                ];
            case 'kid':
                return [
                    { title: 'height', desc: 'heightdesc' },
                    { title: 'chestkids', desc: 'chestkidsdesc' },
                    { title: 'armlength', desc: 'armlengthdesc' },
                    { title: 'waistkids', desc: 'waistkidsdesc' },
                ];
            default:
                return;
        }
    }, [mannequinGender]);
    return (React.createElement("div", { className: "sizechart sizechart--measure" },
        React.createElement("div", { className: "sizechart__wrapper" },
            React.createElement("dl", { className: `sizechart__legend ${mannequinGender}` }, mannequinLabelText === null || mannequinLabelText === void 0 ? void 0 : mannequinLabelText.map((content) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("dt", { className: "font__title" }, t(`sizeguide.howtomeasure.${content.title}`)),
                    React.createElement("dd", { className: "primary-xs" }, t(`sizeguide.howtomeasure.${content.desc}`))));
            }))),
        React.createElement("div", { className: mannequinClass }, mannequinGender !== 'kid' &&
            (mannequinLabelText === null || mannequinLabelText === void 0 ? void 0 : mannequinLabelText.map((content, i) => {
                return React.createElement("div", { className: "sizechart__annotations", key: content.title }, `0${i + 1}`);
            })))));
};
export default HowToMeasure;
